import React from 'react'

const PageNotFound = () => {
        return(
            <div className="text-center bg-danger h1 m-5 p-5">PageNotFound</div>
        )
}

export default PageNotFound